import { useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ExpenseContext } from '@/contexts/ExpenseContext';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const context = useContext(ExpenseContext);
  const authError = context?.authError;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authError) {
      if (location.pathname !== '/' && location.pathname !== '/login') {
        console.log('🚫 Authentication error detected - redirecting to landing page');
        navigate('/', { replace: true });
      }
    }
  }, [authError, navigate, location.pathname]);

  return <>{children}</>;
} 